import { FC, useEffect, useState } from 'react';
import styles from './CloseCross.module.scss';

interface ICloseCrossProps {
    onClose: () => void;
    showAfter?: number;
}

export const CloseCross: FC<ICloseCrossProps> = ({ onClose, showAfter = 0 }) => {
    const [isVisible, setIsVisible] = useState(showAfter === 0);

    useEffect(() => {
        if (showAfter > 0) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, showAfter * 1000);

            return () => clearTimeout(timer);
        }
    }, [showAfter]);

    if (!isVisible) {
        return null;
    }

    return (
        <button 
            className={`${styles.closeButton}`}
            onClick={onClose}
            aria-label="Закрыть"
        >
            <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                    d="M18 6L6 18M6 6L18 18" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};